import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    expediente: [],
    expedientesPersonal: [],
    savedExpedienteId: 0,
    personalExpediente: null,
  },

  getters: {
    getExpedientes: (state) => state.expediente,

    getExpedientesPersonal: (state) => state.expedientesPersonal,

    getIdExpediente: (state) => state.idExpediente,

    getSavedExpedienteId: (state) => state.savedExpedienteId,

    getCuipSelectedExpediente: (state) => state.personalExpediente.CUIP,
  },

  mutations: {
    SET_EXPEDIENTE(state, expediente) {
      state.expediente = expediente;
    },

    SET_EXPEDIENTES_PERSONAL(state, expedientesPersonal) {
      state.expedientesPersonal = expedientesPersonal;
    },

    SET_SAVED_EXPEDIENTE_ID(state, idExpediente) {
      state.savedExpedienteId = idExpediente;
    },

    SET_PERSONAL_FROM_EXPEDIENTE_ID(state, payload) {
      const selectedExpediente = state.expediente.find((item) => item.idExpediente === payload);
      state.personalExpediente = selectedExpediente.Personal;
    },
  },

  actions: {
    async fetchExpedientes({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/expedientes')
        .then((response) => {
          commit('SET_EXPEDIENTE', response.data.data);
        });
    },

    async fetchExpedienteById({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}`)
        .then((response) => {
          commit('SET_EXPEDIENTES_PERSONAL', response.data.data);
        });
    },

    async fetchExpedientesByPersonal({ commit }, idPersonal) {
      await axios
        .get(`PoliciaCuadrantes/C3/personal/${idPersonal}/expedientes`)
        .then((response) => {
          commit('SET_EXPEDIENTES_PERSONAL', response.data.data);
        });
    },

    async saveExpediente(context, expediente) {
      await axios
        .post(`PoliciaCuadrantes/C3/personal/${expediente.fk_idPersonal}/expedientes`, expediente)
        .then((response) => {
          context.commit('SET_SAVED_EXPEDIENTE_ID', response.data.data[0].ID);
          context.commit(
            'SET_SNACKBAR_MESSAGE',
            'Expediente registrado correctamente. Actualizando lista de expedientes, espere unos segundos...',
            {
              root: true,
            },
          );
        });
    },

    async updateExpediente(_, expediente) {
      await axios
        .put(`PoliciaCuadrantes/C3/personal/${expediente.idPersonal}/expedientes/${expediente.id}`, expediente);
    },

    async updateFolioExpediente(_, expediente) {
      await axios
        .put(`EonCloud/C3/personal/${expediente.idPersonal}/expedientes/${expediente.id}/setFolio`, {
          folio: expediente.folio,
        });
    },
  },
};
